import { ProductBaseConfig } from '../types/productBase';

/**
 * Product base configurations (static data only)
 * Text content is managed through i18n translations in locales/*.json
 */
export const personalPrizeConfig: ProductBaseConfig = {
  id: 'personal-prize',
  i18nKey: 'personalPrize', // Matches key in locales/*.json under products.personalPrize
  logo: '/personal-prize/logo.png',
  accentColor: '#7c5cff',
  gradientColors: {
    start: '#7c5cff',
    end: '#4ad9a6',
  },
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.infinitewing.jp_lottery',
  appStoreUrl: 'https://apps.apple.com/us/app/personal-prize-couple-gifts/id6764363677',
  webAppUrl: 'https://synorlab.com/personal-prize/app',
  privacyUrl: '/personal-prize/privacy',
  termsUrl: '/personal-prize/terms',
  screenshots: [
    { 
      image: '/personal-prize/1.png', 
      alt: 'Personal Prize Screenshot', 
      i18nLabelKey: 'screenshots.0.label' // Will read from products.personalPrize.screenshots[0].label
    },
    { image: '/personal-prize/2.png', alt: 'Personal Prize Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/personal-prize/3.png', alt: 'Personal Prize Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/personal-prize/4.png', alt: 'Personal Prize Screenshot', i18nLabelKey: 'screenshots.3.label' },
    { image: '/personal-prize/5.png', alt: 'Personal Prize Screenshot', i18nLabelKey: 'screenshots.4.label' },
  ],
};

export const wayHomeConfig: ProductBaseConfig = {
  id: 'wayhome',
  i18nKey: 'wayHome', // Matches key in locales/*.json under products.wayHome
  logo: '/wayhome/logo.png',
  accentColor: '#ff9f5a',
  gradientColors: {
    start: '#ff9f5a',
    end: '#ffd36b',
  },
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.infinitewing.waybackhome',
  privacyUrl: '/wayhome/privacy',
  termsUrl: '/wayhome/terms',
  screenshots: [
    { image: '/wayhome/0.png', alt: 'Way Home Screenshot', i18nLabelKey: 'screenshots.0.label' },
    { image: '/wayhome/1.png', alt: 'Way Home Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/wayhome/2.png', alt: 'Way Home Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/wayhome/3.png', alt: 'Way Home Screenshot', i18nLabelKey: 'screenshots.3.label' },
    { image: '/wayhome/4.png', alt: 'Way Home Screenshot', i18nLabelKey: 'screenshots.4.label' },
  ],
};

export const infinityBrainConfig: ProductBaseConfig = {
  id: 'infinity-brain',
  i18nKey: 'infinityBrain', // Matches key in locales/*.json under products.infinityBrain
  logo: '/infinity-brain/logo.png',
  accentColor: '#5c9fff',
  gradientColors: {
    start: '#5c9fff',
    end: '#a66dff',
  },
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.infinitewing.braintraining',
  privacyUrl: '/infinity-brain/privacy',
  termsUrl: '/infinity-brain/terms',
  videoUrl: 'https://www.youtube.com/watch?v=uo6AvGSYdYw',
  screenshots: [
    { image: '/infinity-brain/1.jpg', alt: 'Infinity Brain Training Screenshot', i18nLabelKey: 'screenshots.0.label' },
    { image: '/infinity-brain/2.jpg', alt: 'Infinity Brain Training Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/infinity-brain/3.jpg', alt: 'Infinity Brain Training Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/infinity-brain/4.jpg', alt: 'Infinity Brain Training Screenshot', i18nLabelKey: 'screenshots.3.label' },
    { image: '/infinity-brain/5.jpg', alt: 'Infinity Brain Training Screenshot', i18nLabelKey: 'screenshots.4.label' },
  ],
};

export const personalVaultConfig: ProductBaseConfig = {
  id: 'personal-vault',
  i18nKey: 'personalVault', // Matches key in locales/*.json under products.personalVault
  logo: '/personal-vault/logo.png',
  accentColor: '#4ad9a6',
  gradientColors: {
    start: '#4ad9a6',
    end: '#2563eb',
  },
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.infinitewing.personal_vault',
  appStoreUrl: 'https://apps.apple.com/us/app/personal-vault-secure-app/id6764363583',
  webAppUrl: 'https://synorlab.com/personal-vault/app',
  privacyUrl: '/personal-vault/privacy',
  termsUrl: '/personal-vault/terms',
  screenshots: [
    { image: '/personal-vault/1.png', alt: 'Personal Vault Screenshot', i18nLabelKey: 'screenshots.0.label' },
    { image: '/personal-vault/2.png', alt: 'Personal Vault Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/personal-vault/3.png', alt: 'Personal Vault Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/personal-vault/4.png', alt: 'Personal Vault Screenshot', i18nLabelKey: 'screenshots.3.label' },
    { image: '/personal-vault/5.png', alt: 'Personal Vault Screenshot', i18nLabelKey: 'screenshots.4.label' },
  ],
};

export const bombWorldClassicConfig: ProductBaseConfig = {
  id: 'bomb-world-classic',
  i18nKey: 'bombWorldClassic',
  logo: '/bombworld/logo.png',
  accentColor: '#3b9eff',
  gradientColors: {
    start: '#3b9eff',
    end: '#ff6b2b',
  },
  comingSoonPlayStore: true,
  appStoreUrl: 'https://apps.apple.com/us/app/bomb-world-classic/id6814187522',
  privacyUrl: '/bomb-world-classic/privacy',
  termsUrl: '/bomb-world-classic/terms',
  screenshots: [
    { image: '/bombworld/1.png', alt: 'Bomb World: Classic Screenshot', i18nLabelKey: 'screenshots.0.label' },
    { image: '/bombworld/2.png', alt: 'Bomb World: Classic Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/bombworld/3.png', alt: 'Bomb World: Classic Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/bombworld/4.png', alt: 'Bomb World: Classic Screenshot', i18nLabelKey: 'screenshots.3.label' },
  ],
};

export const personalContactConfig: ProductBaseConfig = {
  id: 'personal-contact',
  i18nKey: 'personalContact',
  logo: '/personal-contact/logo.png',
  accentColor: '#8b5cf6',
  gradientColors: {
    start: '#7c5cff',
    end: '#38bdf8',
  },
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.infinitewing.personal_contact',
  appStoreUrl: 'https://apps.apple.com/us/app/personal-contact-keep-context/id6813769143',
  privacyUrl: '/personal-contact/privacy',
  termsUrl: '/personal-contact/terms',
  screenshots: [
    { image: '/personal-contact/1.png', alt: 'Personal Contact Screenshot', i18nLabelKey: 'screenshots.0.label' },
    { image: '/personal-contact/2.png', alt: 'Personal Contact Screenshot', i18nLabelKey: 'screenshots.1.label' },
    { image: '/personal-contact/3.png', alt: 'Personal Contact Screenshot', i18nLabelKey: 'screenshots.2.label' },
    { image: '/personal-contact/4.png', alt: 'Personal Contact Screenshot', i18nLabelKey: 'screenshots.3.label' },
    { image: '/personal-contact/5.png', alt: 'Personal Contact Screenshot', i18nLabelKey: 'screenshots.4.label' },
  ],
};

